import React, { useState } from 'react';

const CloneTemplateDialog = ({ open, source, onClose, onSubmit }) => {
  const [form, setForm] = useState({
    name: source ? `${source.name} (Clone)` : '',
    code: source ? `${source.code}_CLONE` : '',
    departmentLabel: '',
    contractType: '',
    financialYear: '',
  });

  React.useEffect(() => {
    if (source) {
      setForm({
        name: `${source.name} (Clone)`,
        code: `${source.code}_CLONE`,
        departmentLabel: '',
        contractType: '',
        financialYear: '',
      });
    }
  }, [source]);

  if (!open || !source) return null;

  return (
    <div className="ra-tpl-modal-overlay" onClick={onClose}>
      <div className="ra-tpl-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Clone Template</h3>
        <p className="ra-tpl-help">Clone from <strong>{source.name}</strong></p>
        <div className="form-group">
          <label>New Template Name</label>
          <input value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Code</label>
          <input value={form.code} onChange={(e) => setForm((p) => ({ ...p, code: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Department (note)</label>
          <input value={form.departmentLabel} onChange={(e) => setForm((p) => ({ ...p, departmentLabel: e.target.value }))} placeholder="Railways" />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Contract Type</label>
            <input value={form.contractType} onChange={(e) => setForm((p) => ({ ...p, contractType: e.target.value }))} placeholder="Item Rate" />
          </div>
          <div className="form-group">
            <label>Financial Year</label>
            <input value={form.financialYear} onChange={(e) => setForm((p) => ({ ...p, financialYear: e.target.value }))} placeholder="Optional" />
          </div>
        </div>
        <div className="ra-tpl-modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          <button
            type="button"
            className="btn-primary"
            onClick={() => onSubmit({
              code: form.code,
              name: form.name,
              contractType: form.contractType || undefined,
              financialYear: form.financialYear || undefined,
              metadata: form.departmentLabel ? { departmentNote: form.departmentLabel } : undefined,
            })}
          >
            Clone and Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloneTemplateDialog;
